var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04482 12.3341H13.0779M1.01172 12.3341H2.13424C2.46216 12.3341 2.62613 12.3341 2.78042 12.2973C2.91722 12.2646 3.048 12.2108 3.16795 12.1377C3.30325 12.0552 3.41919 11.9399 3.65107 11.7093L12.0725 3.33414C12.6278 2.78185 12.6278 1.88642 12.0725 1.33413C11.5171 0.781851 10.6168 0.781851 10.0614 1.33414L1.64001 9.7093C1.40813 9.9399 1.29219 10.0552 1.20928 10.1898C1.13577 10.3091 1.08161 10.4391 1.04876 10.5752C1.01172 10.7286 1.01172 10.8917 1.01172 11.2178V12.3341Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLogo);
export default __webpack_public_path__ + "static/media/Edit-logo.4c601bde571f65073be22c9b6ba395a5.svg";
export { ForwardRef as ReactComponent };